import { PaymentScheme } from '@shared/api/graphql/generated';

import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';

export const getFormatNextBillingDate = (
  nextBillingDate: string,
  paymentScheme: PaymentScheme | null = PaymentScheme.InvoiceCalendarMonthly
): string => {
  const startDate = new Date();

  let endDate;

  if (paymentScheme === PaymentScheme.InvoiceCalendarMonthly) {
    endDate = nextBillingDate
      ? DateUtils.subDays(new Date(nextBillingDate), 1)
      : DateUtils.getLastDayOfMonth(startDate);
  } else {
    endDate = nextBillingDate ? DateUtils.subDays(new Date(nextBillingDate), 1) : DateUtils.addMonths(startDate, 1);
  }

  const formatStartNextBillingDate = DateUtils.getFormatDateFrom(startDate, 'dd.MM');
  const formatEndNextBillingDate = DateUtils.getFormatDateFrom(endDate, 'dd.MM');

  return `${formatStartNextBillingDate} - ${formatEndNextBillingDate}`;
};
